<form [formGroup]="formGroup">
  <div class="content-top-row justify-space-between gap-5">
    <mat-form-field class="top-row-first-filed-item top-row-first-filed-item-order-processing ml-0 w-100">
      <input type="text" [placeholder]="placeHolder" matInput [formControlName]="formControlName"
        (input)="filterChanged($event)" [matAutocomplete]="auto">
      <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete">
        <mat-option disabled>Please select</mat-option>
        <mat-tree [dataSource]="dataSource" [treeControl]="treeControl">
          <!-- This is the tree node template for leaf nodes -->
          <mat-tree-node *matTreeNodeDef="let node" matTreeNodePadding>
            <li>
              <div class="mat-tree-node cursor-pointer transition-all duration-150 hover:text-green hover:font-bold"
                (click)="onClickNode(node)">
                {{node.name}}
              </div>
            </li>
          </mat-tree-node>
          <!-- This is the tree node template for expandable nodes -->
          <mat-tree-node *matTreeNodeDef="let node;when: hasChild" matTreeNodePadding>
            <li class="dropdown-tree-container">
              <div class="mat-tree-node">
                <button mat-icon-button matTreeNodeToggle [attr.aria-label]="'Toggle ' + node.name">
                  <mat-icon color="primary"
                    class="mat-icon-rtl-mirror">
                    {{treeControl.isExpanded(node) ? 'remove_circle' : 'add_circle'}}
                  </mat-icon>
                </button>
                <span class="cursor-pointer transition-all duration-150 hover:text-primary hover:font-bold"
                  (click)="onClickNode(node)">
                  {{node.name}}
                </span>
              </div>
              <ul class="dropdown-tree-nested-node">
                <div *ngIf="treeControl.isExpanded(node)">
                  <ng-container matTreeNodeOutlet></ng-container>
                </div>
              </ul>
            </li>
          </mat-tree-node>
        </mat-tree>
      </mat-autocomplete>
      <mat-error *ngIf="formGroup.invalid && formGroup.get(formControlName).hasError('required')">
        <div class="flex justify-flex-start align-flex-center">
          <span>{{ "Required"}}</span>
        </div>
      </mat-error>
    </mat-form-field>
  </div>
</form>